"use client";
import React, { useState, useRef, useEffect } from "react";
import { Typography } from "@material-ui/core";
import { useDispatch } from "react-redux";
import DataTable from "../../components/Flight/components/DataTable";
import axios from "axios";
import moment from "moment";
import FlightProviders from "../../components/Flight/utils/FlightProviders";

import Services from "../../components/Flight/components/Services/Services";
import FlightSearch from "../../components/Flight/FlightSearch/FlightSearchV2";
import PopularDestinations from "../../components/Flight/components/PopularDestinations/PopularDestinations";
import LocalDestinations from "../../components/Flight/components/LocalDestinations/LocalDestinations";
import { momentToHrs } from "../../helpers/date.helper";
import { addToHistory } from "../../components/Flight/utils/SearchHistory";
import Footer from "../../components/Flight/components/Home Footer/Footer";
import "./home.css";
import Loader from "../../components/Loader/Loader";
import banner from "../../assets/img/bannerimage.png";
import Typed from "typed.js";

export default function Home(props) {
  const [journeyType, setJourneyType] = useState("One Way");
  const [selectedArrivalDate, setSelectedArrivalDate] = useState();
  const [selectedDepartureDate, setSelectedDepartureDate] = useState();
  const [departureAirport, setDepartureAirport] = useState("");
  const [departureAirportName, setDepartureAirportName] = useState("");
  const [arrivalAirport, setArrivalAirport] = useState("");
  const [arrivalAirportName, setArrivalAirportName] = useState("");
  const [adults, setAdults] = useState(1);
  const [kids, setKids] = useState(0);
  const [infants, setInfants] = useState(0);
  const [flightClass, setFlightClass] = useState("Any");
  const [flights, setFlights] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortBy, setSortBy] = useState("price");

  /////////////////////////FILTERS////////////////////////////////

  const [flyDuration, setFlyDuration] = useState(1);
  const [useflyDuration, setUseFlyDuration] = useState(false);
  const [useSortBy, setUseSortBy] = useState(false);
  const [priceRange, setPriceRange] = useState([0, 1000]);
  const [usePriceRange, setUsePriceRange] = useState(false);
  const [arrivalTimeRange, setArrivalTimeRange] = useState({
    min: new Date(),
    max: new Date(),
  });
  const [useArrivalTimeRange, setUseArrivalTimeRange] = useState(false);
  const [baggage, setBaggage] = useState({
    hand_bag: "0",
    hold_bag: "0",
  });
  const [useBaggage, setUseBaggage] = useState(false);
  const [departureTimeRange, setDepartureTimeRange] = useState({
    min: new Date(),
    max: new Date(),
  });
  const [useDepartureTimeRange, setUseDepartureTimeRange] = useState(false);
  const [stops, setStops] = useState("-1");
  const [useStops, setUseStops] = useState(false);
  const SESSION_KEY = "SESSION_KEY";

  const vendorCommission = { type: "Fixed", value: 0 };
  const adminCommission = { type: "Fixed", value: 0 };

  // const typedRef = useRef(null);

  // useEffect(() => {
  //   const typed = new Typed(typedRef.current, {
  //     strings: [
  //       "YOU FLY FOR LESS",
  //       "FIND THE BEST DEALS",
  //       "COMPARE & SAVE",
  //       "TRAVEL SMART",
  //     ],
  //     typeSpeed: 40,
  //     backSpeed: 30,
  //     backDelay: 1500,
  //     startDelay: 500,
  //     loop: true,
  //     showCursor: true,
  //     cursorChar: "✈",
  //     autoInsertCss: true,
  //     fadeOut: true,
  //     fadeOutClass: "typed-fade-out",
  //     fadeOutDelay: 500,
  //     onStringTyped: (arrayPos) => {
  //       // Optional: Add any additional effects when a string is typed
  //     },
  //   });

  //   return () => {
  //     typed.destroy();
  //   };
  // }, []);

  function onPopularDestinationClicked({ start, end, DepDate }) {
    setDepartureAirport(start.code);
    setArrivalAirport(end.code);
    setDepartureAirportName(start.name);
    setArrivalAirportName(end.name);
    setSelectedDepartureDate(DepDate);
  }

  const dispatch = useDispatch();

  function createUTCdateForISO(dateString) {
    if (dateString == null || dateString == undefined) return null;
    const offset = new Date().getTimezoneOffset();
    const myDate = Date.parse(dateString) + offset * 60 * 1000;
    const dateAsISO = new Date(myDate).toISOString();
    return dateAsISO;
  }

  const searchFlights = async function () {
    if (!departureAirport || !arrivalAirport || !selectedDepartureDate) {
      return;
    }
    if (journeyType === "Return" && !selectedArrivalDate) {
      return;
    }

    setLoading(true);
    setFlights([]);

    let normalQueryParam = `/flights/airlines-offer?fly_from=${departureAirport}&date_from=${moment(
      selectedDepartureDate
    ).format(
      "DD/MM/yyyy"
    )}&fly_to=${arrivalAirport}&limit=250&adults=${adults}&children=${kids}&infants=${infants}`;
    const airiqQueryParam = `/flights/offers-airiq?date_from=${moment(
      selectedDepartureDate
    ).format(
      "yyyy/MM/DD"
    )}&fly_from=${departureAirport}&fly_to=${arrivalAirport}&adults=${adults}&children=${kids}&infants=${infants}`;
    const tboQueryParam = `/flights/offers-tbo?date_from=${moment(
      selectedDepartureDate
    ).format(
      "yyyy-MM-DD"
    )}&fly_from=${departureAirport}&fly_to=${arrivalAirport}&adults=${adults}&children=${kids}&infants=${infants}${
      journeyType === "Return" && selectedArrivalDate
        ? `&date_to=${moment(selectedArrivalDate).format("yyyy-MM-DD")}`
        : ""
    }`;

    if (flightClass && flightClass !== "Any") {
      normalQueryParam += `&selected_cabins=${flightClass}`;
    }

    try {
      const [
        normalFlightResponse,
        airiqFlightResponse,
        tboFlightResponse,
      ] = await Promise.allSettled([
        axios.get(normalQueryParam),
        axios.get(airiqQueryParam),
        axios.get(tboQueryParam),
      ]);

      let allFlights = [];

      // KIWI
      if (
        normalFlightResponse.status === "fulfilled" &&
        normalFlightResponse.value.data &&
        normalFlightResponse.value.data.data
      ) {
        let data = normalFlightResponse.value.data.data.data || [];
        data.forEach((d) => {
          let slices = [];
          if (journeyType !== "Return") {
            let slice = {
              origin: departureAirport,
              destination: arrivalAirport,
              duration: d.duration.departure,
              airline: {},
            };
            let segments = [];
            d.route.forEach((route) => {
              segments.push(route);
              slice.airline[route.airline] = 1;
            });
            slice.segments = segments;
            slices.push(slice);
          } else {
            let segments = [];
            let slice = {
              origin: departureAirport,
              destination: arrivalAirport,
              duration: d.duration.departure,
              airline: {},
            };
            d.route.forEach((route) => {
              segments.push(route);
              slice.airline[route.airline] = 1;
              if (route.flyTo === arrivalAirport) {
                slice.segments = [...segments];
                slices.push({ ...slice });
                segments = [];
                slice = {
                  destination: departureAirport,
                  origin: arrivalAirport,
                  duration: d.duration.return,
                  airline: {},
                };
              }
            });
            slice.segments = [...segments];
            slices.push({ ...slice });
          }
          d.slices = slices;
          d.provider = FlightProviders.KIWI;
          allFlights.push(d);
        });
      }

      // AIRIQ
      if (
        !(journeyType === "Return" && selectedArrivalDate) &&
        airiqFlightResponse.status === "fulfilled" &&
        airiqFlightResponse.value.data
      ) {
        const { data = [] } = airiqFlightResponse.value.data;
        data.forEach((d) => {
          const slices = [
            {
              duration:
                (new Date(`${d.arival_date} ${d.arival_time}`) -
                  new Date(`${d.departure_date} ${d.departure_time}`)) /
                1000,
              airline: { [d.flight_number.split(" ")[0]]: 1 },
              segments: [
                {
                  flyFrom: d.origin,
                  flyTo: d.destination,
                  flight_number: d.flight_number.split(" ")[1],
                  fare_category: "M",
                  operating_carrier: d.flight_number.split(" ")[0],
                  airline: d.flight_number.split(" ")[0],
                  local_departure: `${d.departure_date} ${d.departure_time}:00.000Z`,
                  utc_departure: createUTCdateForISO(
                    `${d.departure_date} ${d.departure_time}`
                  ),
                  local_arrival: `${d.arival_date} ${d.arival_time}:00.000Z`,
                  utc_arrival: createUTCdateForISO(
                    `${d.arival_date} ${d.arival_time}`
                  ),
                },
              ],
            },
          ];
          allFlights.push({
            ticked_id: d.ticket_id,
            flight_id: d.flight_number.replace(" ", "-"),
            slices,
            price: d.price,
            provider: FlightProviders.AIRIQ,
          });
        });
      }

      // TBO
      if (
        tboFlightResponse.status === "fulfilled" &&
        tboFlightResponse.value.data
      ) {
        const { data = [], traceId } = tboFlightResponse.value.data;
        if (journeyType === "Return" && data.length >= 2) {
          // For return journeys, process both outbound and return flights
          const outboundFlights = data[0] || [];
          const returnFlights = data[1] || [];
          const combinedFlights = [];
          const maxOutbound = Math.min(outboundFlights.length, 20);
          const maxReturn = Math.min(returnFlights.length, 20);
          for (let i = 0; i < maxOutbound; i++) {
            const outboundFlight = outboundFlights[i];
            if (
              !outboundFlight?.Segments ||
              !Array.isArray(outboundFlight.Segments) ||
              outboundFlight.Segments.length === 0
            )
              continue;
            const outboundSegmentsArray = outboundFlight.Segments[0];
            if (
              !Array.isArray(outboundSegmentsArray) ||
              outboundSegmentsArray.length === 0
            )
              continue;
            const outboundMappedSegments = outboundSegmentsArray
              .map((segment) => {
                if (
                  !segment?.Origin?.Airport?.AirportCode ||
                  !segment?.Destination?.Airport?.AirportCode ||
                  !segment?.Airline
                )
                  return null;
                return {
                  flyFrom: segment.Origin.Airport.AirportCode,
                  flyTo: segment.Destination.Airport.AirportCode,
                  flight_no: segment.Airline.FlightNumber,
                  fare_category: segment.Airline.FareClass || "ECONOMY",
                  operating_carrier: segment.Airline.AirlineCode,
                  airline:
                    segment.Airline.AirlineName || segment.Airline.AirlineCode,
                  local_departure: segment.Origin.DepTime,
                  utc_departure: createUTCdateForISO(segment.Origin.DepTime),
                  local_arrival: segment.Destination.ArrTime,
                  utc_arrival: createUTCdateForISO(segment.Destination.ArrTime),
                };
              })
              .filter(Boolean);
            if (outboundMappedSegments.length === 0) continue;
            const outboundFirstSegment = outboundSegmentsArray[0];
            const outboundLastSegment =
              outboundSegmentsArray[outboundSegmentsArray.length - 1];
            const outboundDuration =
              (new Date(outboundLastSegment.Destination.ArrTime) -
                new Date(outboundFirstSegment.Origin.DepTime)) /
              1000;
            for (let j = 0; j < maxReturn; j++) {
              const returnFlight = returnFlights[j];
              if (
                !returnFlight?.Segments ||
                !Array.isArray(returnFlight.Segments) ||
                returnFlight.Segments.length === 0
              )
                continue;
              const returnSegmentsArray = returnFlight.Segments[0];
              if (
                !Array.isArray(returnSegmentsArray) ||
                returnSegmentsArray.length === 0
              )
                continue;
              const returnMappedSegments = returnSegmentsArray
                .map((segment) => {
                  if (
                    !segment?.Origin?.Airport?.AirportCode ||
                    !segment?.Destination?.Airport?.AirportCode ||
                    !segment?.Airline
                  )
                    return null;
                  return {
                    flyFrom: segment.Origin.Airport.AirportCode,
                    flyTo: segment.Destination.Airport.AirportCode,
                    flight_no: segment.Airline.FlightNumber,
                    fare_category: segment.Airline.FareClass || "ECONOMY",
                    operating_carrier: segment.Airline.AirlineCode,
                    airline:
                      segment.Airline.AirlineName ||
                      segment.Airline.AirlineCode,
                    local_departure: segment.Origin.DepTime,
                    utc_departure: createUTCdateForISO(segment.Origin.DepTime),
                    local_arrival: segment.Destination.ArrTime,
                    utc_arrival: createUTCdateForISO(
                      segment.Destination.ArrTime
                    ),
                  };
                })
                .filter(Boolean);
              if (returnMappedSegments.length === 0) continue;
              const returnFirstSegment = returnSegmentsArray[0];
              const returnLastSegment =
                returnSegmentsArray[returnSegmentsArray.length - 1];
              const returnDuration =
                (new Date(returnLastSegment.Destination.ArrTime) -
                  new Date(returnFirstSegment.Origin.DepTime)) /
                1000;
              const slices = [
                {
                  origin: departureAirport,
                  destination: arrivalAirport,
                  duration: outboundDuration,
                  airline: { [outboundFirstSegment.Airline.AirlineCode]: 1 },
                  segments: outboundMappedSegments,
                },
                {
                  origin: arrivalAirport,
                  destination: departureAirport,
                  duration: returnDuration,
                  airline: { [returnFirstSegment.Airline.AirlineCode]: 1 },
                  segments: returnMappedSegments,
                },
              ];
              combinedFlights.push({
                ticked_id: `${outboundFlight.Source}-${returnFlight.Source}`,
                flight_id: `${outboundFirstSegment.Airline.FlightNumber}-${returnFirstSegment.Airline.FlightNumber}`,
                slices,
                price:
                  outboundFlight.Fare.OfferedFare +
                  returnFlight.Fare.OfferedFare,
                baglimit: {
                  hand_weight: outboundFirstSegment.CabinBaggage || "0 KG",
                  hold_weight: outboundFirstSegment.Baggage || "0 KG",
                },
                provider: FlightProviders.TBO,
                ResultIndex: [
                  "" + outboundFlight.ResultIndex,
                  "" + returnFlight.ResultIndex,
                ],
                TraceId: traceId,
                IsRefundable:
                  outboundFlight.IsRefundable && returnFlight.IsRefundable,
              });
            }
          }
          allFlights.push(...combinedFlights);
        } else if (journeyType === "Return" && data.length >= 1) {
          const outboundFlights = data[0] || [];
          const singleArrayReturnFlights = [];
          const maxFlights = Math.min(outboundFlights.length, 40);
          for (let i = 0; i < maxFlights; i++) {
            const flight = outboundFlights[i];
            if (
              !flight?.Segments ||
              !Array.isArray(flight.Segments) ||
              flight.Segments.length < 2
            )
              continue;
            const outboundSegmentsArray = flight.Segments[0];
            const returnSegmentsArray = flight.Segments[1];
            if (
              !Array.isArray(outboundSegmentsArray) ||
              outboundSegmentsArray.length === 0 ||
              !Array.isArray(returnSegmentsArray) ||
              returnSegmentsArray.length === 0
            )
              continue;
            const outboundMappedSegments = outboundSegmentsArray
              .map((segment) => {
                if (
                  !segment?.Origin?.Airport?.AirportCode ||
                  !segment?.Destination?.Airport?.AirportCode ||
                  !segment?.Airline
                )
                  return null;
                return {
                  flyFrom: segment.Origin.Airport.AirportCode,
                  flyTo: segment.Destination.Airport.AirportCode,
                  flight_no: segment.Airline.FlightNumber,
                  fare_category: segment.Airline.FareClass || "ECONOMY",
                  operating_carrier: segment.Airline.AirlineCode,
                  airline:
                    segment.Airline.AirlineName || segment.Airline.AirlineCode,
                  local_departure: segment.Origin.DepTime,
                  utc_departure: createUTCdateForISO(segment.Origin.DepTime),
                  local_arrival: segment.Destination.ArrTime,
                  utc_arrival: createUTCdateForISO(segment.Destination.ArrTime),
                };
              })
              .filter(Boolean);
            if (outboundMappedSegments.length === 0) continue;
            const returnMappedSegments = returnSegmentsArray
              .map((segment) => {
                if (
                  !segment?.Origin?.Airport?.AirportCode ||
                  !segment?.Destination?.Airport?.AirportCode ||
                  !segment?.Airline
                )
                  return null;
                return {
                  flyFrom: segment.Origin.Airport.AirportCode,
                  flyTo: segment.Destination.Airport.AirportCode,
                  flight_no: segment.Airline.FlightNumber,
                  fare_category: segment.Airline.FareClass || "ECONOMY",
                  operating_carrier: segment.Airline.AirlineCode,
                  airline:
                    segment.Airline.AirlineName || segment.Airline.AirlineCode,
                  local_departure: segment.Origin.DepTime,
                  utc_departure: createUTCdateForISO(segment.Origin.DepTime),
                  local_arrival: segment.Destination.ArrTime,
                  utc_arrival: createUTCdateForISO(segment.Destination.ArrTime),
                };
              })
              .filter(Boolean);
            if (returnMappedSegments.length === 0) continue;
            const outboundFirstSegment = outboundSegmentsArray[0];
            const outboundLastSegment =
              outboundSegmentsArray[outboundSegmentsArray.length - 1];
            const outboundDuration =
              (new Date(outboundLastSegment.Destination.ArrTime) -
                new Date(outboundFirstSegment.Origin.DepTime)) /
              1000;
            const returnFirstSegment = returnSegmentsArray[0];
            const returnLastSegment =
              returnSegmentsArray[returnSegmentsArray.length - 1];
            const returnDuration =
              (new Date(returnLastSegment.Destination.ArrTime) -
                new Date(returnFirstSegment.Origin.DepTime)) /
              1000;
            const slices = [
              {
                origin: departureAirport,
                destination: arrivalAirport,
                duration: outboundDuration,
                airline: { [outboundFirstSegment.Airline.AirlineCode]: 1 },
                segments: outboundMappedSegments,
              },
              {
                origin: arrivalAirport,
                destination: departureAirport,
                duration: returnDuration,
                airline: { [returnFirstSegment.Airline.AirlineCode]: 1 },
                segments: returnMappedSegments,
              },
            ];
            singleArrayReturnFlights.push({
              ticked_id: flight.Source,
              flight_id: `${outboundFirstSegment.Airline.FlightNumber}-${returnFirstSegment.Airline.FlightNumber}`,
              slices,
              price: flight.Fare.OfferedFare,
              baglimit: {
                hand_weight: outboundFirstSegment.CabinBaggage || "0 KG",
                hold_weight: outboundFirstSegment.Baggage || "0 KG",
              },
              provider: FlightProviders.TBO,
              ResultIndex: flight.ResultIndex,
              TraceId: traceId,
              IsRefundable: flight.IsRefundable,
            });
          }
          allFlights.push(...singleArrayReturnFlights);
        } else {
          // For one-way journeys, process only outbound flights
          const flightsData = data[0]
            ?.map((flight) => {
              if (
                !flight?.Segments ||
                !Array.isArray(flight.Segments) ||
                flight.Segments.length === 0
              )
                return null;
              const segmentsArray = flight.Segments[0];
              if (!Array.isArray(segmentsArray) || segmentsArray.length === 0)
                return null;
              const mappedSegments = segmentsArray
                .map((segment) => {
                  if (
                    !segment?.Origin?.Airport?.AirportCode ||
                    !segment?.Destination?.Airport?.AirportCode ||
                    !segment?.Airline
                  )
                    return null;
                  return {
                    flyFrom: segment.Origin.Airport.AirportCode,
                    flyTo: segment.Destination.Airport.AirportCode,
                    flight_no: segment.Airline.FlightNumber,
                    fare_category: segment.Airline.FareClass || "ECONOMY",
                    operating_carrier: segment.Airline.AirlineCode,
                    airline:
                      segment.Airline.AirlineName ||
                      segment.Airline.AirlineCode,
                    local_departure: segment.Origin.DepTime,
                    utc_departure: createUTCdateForISO(segment.Origin.DepTime),
                    local_arrival: segment.Destination.ArrTime,
                    utc_arrival: createUTCdateForISO(
                      segment.Destination.ArrTime
                    ),
                  };
                })
                .filter(Boolean);
              if (mappedSegments.length === 0) return null;
              const firstSegment = segmentsArray[0];
              const lastSegment = segmentsArray[segmentsArray.length - 1];
              const totalDuration =
                (new Date(lastSegment.Destination.ArrTime) -
                  new Date(firstSegment.Origin.DepTime)) /
                1000;
              const slices = [
                {
                  origin: departureAirport,
                  destination: arrivalAirport,
                  duration: totalDuration,
                  airline: { [firstSegment.Airline.AirlineCode]: 1 },
                  segments: mappedSegments,
                },
              ];
              return {
                ticked_id: flight.Source,
                flight_id: firstSegment.Airline.FlightNumber,
                slices,
                price: flight.Fare.OfferedFare,
                baglimit: {
                  hand_weight: firstSegment.CabinBaggage || "0 KG",
                  hold_weight: firstSegment.Baggage || "0 KG",
                },
                provider: FlightProviders.TBO,
                ResultIndex: flight.ResultIndex,
                TraceId: traceId,
                IsRefundable: flight.IsRefundable,
              };
            })
            .filter(Boolean);
          if (flightsData && flightsData.length > 0) {
            allFlights.push(...flightsData);
          }
        }
      }

      setFlights(allFlights.sort((a, b) => a.price - b.price));
    } catch (err) {
      setFlights([]);
    }
    setLoading(false);
  };

  const handleFlightSelected = (flight) => {
    // You can redirect or show a modal here
    alert("Selected flight: " + JSON.stringify(flight));
  };

  const phrases = ["YOU FLY FOR LESS", "WE HACK THE SYSTEM"];
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [displayText, setDisplayText] = useState("");
  const frameRef = useRef(0);
  const chars = "WE HACK THE SYSTEM";

  useEffect(() => {
    let frame = 0;
    let queue: any[] = [];
    const text = phrases[currentPhraseIndex];
    const oldText = displayText;
    const maxLength = Math.max(text.length, oldText.length);

    for (let i = 0; i < maxLength; i++) {
      const from = oldText[i] || "";
      const to = text[i] || "";
      const start = Math.floor(Math.random() * 20);
      const end = start + Math.floor(Math.random() * 20);
      queue.push({ from, to, start, end });
    }

    const update = () => {
      let output = "";
      let complete = 0;
      for (let i = 0; i < queue.length; i++) {
        let { from, to, start, end } = queue[i];
        if (frame >= end) {
          output += to;
          complete++;
        } else if (frame >= start) {
          output += chars[Math.floor(Math.random() * chars.length)];
        } else {
          output += from;
        }
      }

      setDisplayText(output);

      if (complete < queue.length) {
        frame++;
        frameRef.current = requestAnimationFrame(update);
      } else {
        setTimeout(() => {
          setCurrentPhraseIndex((prev) => (prev + 1) % phrases.length);
        }, 3000); // wait before changing phrase
      }
    };

    cancelAnimationFrame(frameRef.current);
    frameRef.current = requestAnimationFrame(update);

    return () => cancelAnimationFrame(frameRef.current);
  }, [currentPhraseIndex]);

  return (
    <section>
      <div
        style={{
          background: "#1eb5bf",
          padding: "48px",
          textAlign: "center",
          position: "relative",
          // backgroundImage: "url('/img/bannerimage.png')"
          backgroundImage: `url(${banner})`,
          backgroundSize: "auto",
          backgroundRepeat: "repeat",
        }}
        aria-label="Flight deals banner"
      >
        <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700;900&display=swap');

        @keyframes fadeInUp {
          0% { opacity: 0; transform: translateY(30px);}
          100% { opacity: 1; transform: translateY(0);}
        }
      `}</style>
        <h1
          style={{
            color: "#ffffff",
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "2.5rem",
            fontWeight: 700,
            letterSpacing: "0.3em",
            textTransform: "uppercase",
            textShadow: "0 1px 4px rgba(0,0,0,0.15)",
            transition: "all 0.3s ease",
          }}
        >
          {displayText}
        </h1>

        <p
          className="animated-subheadline"
          style={{
            color: "#fefefe",
            fontSize: "1.25rem",
            fontStyle: "italic",
            animation: "fadeInUp 1.5s ease 1.6s both",
          }}
        >
          Book Cheap Flights, Which You Can't Find Anywhere
        </p>

        <div className="searchbar-center-container">
          <FlightSearch
            selectedDepartureDate={selectedDepartureDate}
            setSelectedDepartureDate={setSelectedDepartureDate}
            journeyType={journeyType}
            setJourneyType={setJourneyType}
            selectedArrivalDate={selectedArrivalDate}
            setSelectedArrivalDate={setSelectedArrivalDate}
            departureAirport={departureAirport}
            setDepartureAirport={setDepartureAirport}
            departureAirportName={departureAirportName}
            setDepartureAirportName={setDepartureAirportName}
            arrivalAirport={arrivalAirport}
            setArrivalAirport={setArrivalAirport}
            arrivalAirportName={arrivalAirportName}
            setArrivalAirportName={setArrivalAirportName}
            adults={adults}
            setAdults={setAdults}
            kids={kids}
            setKids={setKids}
            infants={infants}
            setInfants={setInfants}
            flightClass={flightClass}
            setFlightClass={setFlightClass}
            sortBy={sortBy}
            setSortBy={setSortBy}
            flyDuration={flyDuration}
            setFlyDuration={setFlyDuration}
            useflyDuration={useflyDuration}
            setUseFlyDuration={setUseFlyDuration}
            useSortBy={useSortBy}
            setUseSortBy={setUseSortBy}
            priceRange={priceRange}
            setPriceRange={setPriceRange}
            usePriceRange={usePriceRange}
            setUsePriceRange={setUsePriceRange}
            arrivalTimeRange={arrivalTimeRange}
            setArrivalTimeRange={setArrivalTimeRange}
            useArrivalTimeRange={useArrivalTimeRange}
            setUseArrivalTimeRange={setUseArrivalTimeRange}
            baggage={baggage}
            setBaggage={setBaggage}
            useBaggage={useBaggage}
            setUseBaggage={setUseBaggage}
            departureTimeRange={departureTimeRange}
            setDepartureTimeRange={setDepartureTimeRange}
            useDepartureTimeRange={useDepartureTimeRange}
            setUseDepartureTimeRange={setUseDepartureTimeRange}
            stops={stops}
            setStops={setStops}
            useStops={useStops}
            setUseStops={setUseStops}
            onSearchFlights={searchFlights}
          />
        </div>
      </div>

      {/* DataTable and Loader below the banner */}
      {flights && flights.length > 0 && (
        <div style={{ marginTop: 32, padding: "0 15%" }}>
          <DataTable
            data={flights}
            journeyType={journeyType}
            departureAirportName={departureAirportName}
            arrivalAirportName={arrivalAirportName}
            selectedDepartureDate={selectedDepartureDate}
            selectedArrivalDate={selectedArrivalDate}
            currency={props.currency}
            vendorCommission={vendorCommission}
            adminCommission={adminCommission}
            onFlightSelected={handleFlightSelected}
          />
        </div>
      )}
      <Loader show={loading} />
      {/* End Banner Section */}
      {/* <Services /> */}
      <div className="home-container">
        <PopularDestinations onSelect={onPopularDestinationClicked} />
        <LocalDestinations onSelect={onPopularDestinationClicked} />
      </div>
      <Footer />
    </section>
  );
}
